import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import cookie from "react-cookies";
import { translations } from "../translations";
import { BehaviorSubject } from "rxjs";
import { Languages } from "../domain/enums/common/LanguagesEnum";
import localStorageServiceFactory from "./LocalStorageServiceImpl";
import { LanguageService } from "../domain/services/LanguageService";

export const LANGS = [Languages.UA, Languages.EN];
const DEFAULT_LANGUAGE = Languages.UA;

export class LanguageServiceImpl implements LanguageService {
    private constructor() {
        this._currentLang =
            localStorageServiceFactory().getLang() || DEFAULT_LANGUAGE;
    }

    private static _instance: LanguageService;
    private _currentLang: Languages = DEFAULT_LANGUAGE;
    private _langs: Languages[] = LANGS;

    static lang$ = new BehaviorSubject(DEFAULT_LANGUAGE);

    public static getInstance(): LanguageService {
        if (!LanguageServiceImpl._instance) {
            LanguageServiceImpl._instance = new LanguageServiceImpl();
        }
        return LanguageServiceImpl._instance;
    }

    initLanguages(): void {
        i18n.use(initReactI18next).init({
            resources: translations,
            lng: this.currentLang || cookie.load("locale"),
            keySeparator: ".",
        });
    }

    get currentLang(): Languages {
        return this._currentLang;
    }

    get langs(): Languages[] {
        return this._langs;
    }

    setCurrentLang(value: Languages): void {
        this._currentLang = value;
        i18n.changeLanguage(this._currentLang);
        localStorageServiceFactory().setLang(value as Languages);
    }

    notifyListeners(lang: Languages): void {
        LanguageServiceImpl.lang$.next(lang);
    }

    isCurrentLang(lang: Languages): boolean {
        return lang === this.currentLang;
    }

    // getCurrentPhoneNumberLocale(): any {
    //     switch (this.currentLang) {
    //         case Languages.EN:
    //             return require(`react-phone-number-input/locale/en.json`);
    //         case Languages.UA:
    //             return require(`react-phone-number-input/locale/ua.json`);
    //         default:
    //             return require(`react-phone-number-input/locale/en.json`);
    //     }
    // }

    get isUkrainian(): boolean {
        return this._currentLang === Languages.UA;
    }

    get isEnglish(): boolean {
        return this._currentLang === Languages.EN;
    }
}

export default function languageServiceFactory(): LanguageService {
    return LanguageServiceImpl.getInstance();
}
